<template>
  <v-container>
    <contents-layout>
      <template #title>
        <div class="flex-column">
          <div class="page-title">{{$route.name}}</div>
          <div class="title ml-1 mt-2">{{ $moment().format('YYYY-MM-DD') }} 01시 00분 기준 </div>
        </div>
      </template>
      <template #control>
        <v-menu
            v-model="startMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <div style="width: 200px">
              <v-text-field
                  v-model="startDate"
                  label="시작일"
                  prepend-icon="event"
                  readonly
                  v-on="on"
              ></v-text-field>
            </div>
          </template>
          <c-date-picker v-model="startDate" @input="startMenu = false" locale="ko-kr"
                         firstDayOfWeek="1" :selectedDate="startDate" :allowed-dates="allowDates" :min="limitedDate"></c-date-picker>
        </v-menu>
        <v-menu
            v-model="endMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <div class="ml-5" style="width: 200px">
              <v-text-field
                  v-model="endDate"
                  label="종료일"
                  prepend-icon="event"
                  readonly
                  v-on="on"
              ></v-text-field>
            </div>
          </template>
          <c-date-picker v-model="endDate" @input="endMenu = false" locale="ko-kr"
                         firstDayOfWeek="1" :selectedDate="endDate" :allowed-dates="allowDates" :min="limitedDate"></c-date-picker>
        </v-menu>
      </template>
      <template #content>
        <v-card outlined class="pa-5">
          <v-row>
            <v-col cols="12" class="pb-0">
              <div class="page-title font-weight-bold">주행 누적 통계</div>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <stat-info-card title="탑승 인원(명)" :value="numberFormatter(cumulativeStat['customers'])"></stat-info-card>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <stat-info-card title="이용 시간" :value="toFormatTime(cumulativeStat['totalUsageTime'])"></stat-info-card>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <stat-info-card title="주행 거리(km)" :value="toKilometer(cumulativeStat['totalDistances'])"></stat-info-card>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <stat-info-card title="평균 주행 거리(km)" :value="toKilometer(cumulativeStat['averageDistance'])"></stat-info-card>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <stat-info-card title="주행 건수(건)" :value="numberFormatter(cumulativeStat['drivings'])"></stat-info-card>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <stat-info-card title="배송 건수(건)" :value="numberFormatter(cumulativeStat['deliveries'])"></stat-info-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div class="page-title font-weight-bold">요금 통계</div>
            </v-col>
            <v-col cols="12">
              <v-row class="mt-0">
                <v-col>
                  <stat-info-card title="주행 요금(원)" :value="numberFormatter(statistics['totalFareStat']['driving'])"></stat-info-card>
                </v-col>
                <v-col>
                  <stat-info-card title="대기 요금(원)" :value="numberFormatter(statistics['totalFareStat']['waiting'])"></stat-info-card>
                </v-col>
                <v-col>
                  <stat-info-card title="도움서비스 요금(원)" :value="numberFormatter(statistics['totalFareStat']['service'])"></stat-info-card>
                </v-col>
                <v-col>
                  <stat-info-card title="추가 요금(원)" :value="numberFormatter(statistics['totalFareStat']['extra'])"></stat-info-card>
                </v-col>
                <v-col>
                  <stat-info-card title="할인 요금(원)" :value="numberFormatter(statistics['totalFareStat']['discount'])"></stat-info-card>
                </v-col>
                <v-col>
                  <stat-info-card title="배송 요금(원)" :value="numberFormatter(statistics['totalFareStat']['delivery'])"></stat-info-card>
                </v-col>
                <v-col>
                  <stat-info-card title="총 요금(원)" subtitle="(실 결제 요금 + 미수금)" :value="numberFormatter(statistics['totalFareStat']['total'])"></stat-info-card>
                </v-col>
                <v-col>
                  <stat-info-card title="미수금(원)" :value="numberFormatter(statistics['totalFareStat']['unpaid'])"></stat-info-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-card outlined class="pa-4">
            <v-row justify="end">
            </v-row>
            <v-row>
              <v-col cols="12" md="6" sm="6">
                <v-row justify="center" class="mb-2">
                  <span class="subtitle-1 font-weight-bold">서비스 이용 현황</span>
                </v-row>
                <c-chart-line
                    :labels="lineChartData.labels"
                    :datasets="lineChartData.datasets"
                    :scales="lineChartData.scales"
                    :legend="lineChartData.legend"
                    class="pa-4"
                />
              </v-col>
              <v-col cols="12" md="6" sm="6">
                <v-row justify="center" class="mb-2">
                  <span class="subtitle-1 font-weight-bold">요일별 평균 서비스 이용 현황</span>
                </v-row>
                <c-chart-bar
                    :labels="barChartData.labels"
                    :datasets="barChartData.datasets"
                    :scales="barChartData.scales"
                    :legend="barChartData.legend"
                    class="pa-4"
                />
              </v-col>
            </v-row>
          </v-card>
          <v-row>
            <v-col cols="12" md="6">
              <v-row>
                <v-col cols="12">
                  <v-card outlined>
                    <v-col cols="12">
                      <div class="page-title font-weight-bold">예약 통계</div>
                    </v-col>
                    <v-col cols="12">
                      <v-row>
                        <v-col>
                          <span>신청 건수(건)</span>
                          <span class="ml-5">{{ statistics['totalReservationStat']['totalRequests'] }}</span>
                        </v-col>
                        <v-col>
                          <span>예약률(%)</span>
                          <span class="ml-5">{{ reservationRate }}</span>
                        </v-col>
                        <v-col>
                          <span>당일 예약률(%)</span>
                          <span class="ml-5">{{ sameDayReservationRate }}</span>
                        </v-col>
                        <v-col>
                          <span>주행률(%)</span>
                          <span class="ml-5">{{ doneDrivingRate }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="ml-2" v-if="appVersion !== 'drt'">
                      <span>시내</span>
                      <span class="ml-10 mr-12">{{ statistics['totalDrivingUsageStat']['urbanStat']['시내'] }}</span>
                      <span>시외</span>
                      <span class="ml-10 mr-12">{{ statistics['totalDrivingUsageStat']['urbanStat']['시외'] }}</span>
                    </v-col>
                    <v-col cols="12">
                      <v-row>
                        <v-col class="pa-10">
                          <div class="subtitle-1 text-center font-weight-bold mb-3">예약 완료 수</div>
                          <v-row>
                            <v-col cols="3" class="text-center font-weight-bold statistic-table">예약 시기</v-col>
                            <v-col class="text-center font-weight-bold statistic-table__right">주행 건수(건)</v-col>
                            <v-col class="text-center font-weight-bold statistic-table__right">탑승 인원(명)</v-col>
                            <v-col class="text-center font-weight-bold statistic-table__right">이용 건수(건)</v-col>
                            <v-col class="text-center font-weight-bold statistic-table__right">이용자 수(명)</v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="3" class="text-center statistic-table__bottom">당일 예약</v-col>
                            <v-col class="text-center statistic-table__bottom-right">{{ statistics['totalReservationStat']['sameDayReservations'] }}</v-col>
                            <v-col class="text-center statistic-table__bottom-right">{{ statistics['totalReservationStat']['sameDayReservationCustomers'] }}</v-col>
                            <v-col class="text-center statistic-table__bottom-right">{{ statistics['totalReservationStat']['sameDayReservationUsingCnt'] }}</v-col>
                            <v-col class="text-center statistic-table__bottom-right">{{ statistics['totalReservationStat']['sameDayReservationUserCnt'] }}</v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="3" class="text-center statistic-table__bottom">당일 이후 예약</v-col>
                            <v-col class="text-center statistic-table__bottom-right">{{ statistics['totalReservationStat']['afterDayReservations'] }}</v-col>
                            <v-col class="text-center statistic-table__bottom-right">{{ statistics['totalReservationStat']['afterDayReservationCustomers'] }}</v-col>
                            <v-col class="text-center statistic-table__bottom-right">{{ statistics['totalReservationStat']['afterDayReservationUsingCnt'] }}</v-col>
                            <v-col class="text-center statistic-table__bottom-right">{{ statistics['totalReservationStat']['afterDayReservationUserCnt'] }}</v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="3" class="text-center statistic-table__bottom">합계</v-col>
                            <v-col class="text-center statistic-table__bottom-right">
                              {{ statistics['totalReservationStat']['sameDayReservations'] + statistics['totalReservationStat']['afterDayReservations'] }}
                            </v-col>
                            <v-col class="text-center statistic-table__bottom-right">
                              {{ statistics['totalReservationStat']['sameDayReservationCustomers'] + statistics['totalReservationStat']['afterDayReservationCustomers'] }}
                            </v-col>
                            <v-col class="text-center statistic-table__bottom-right">
                              {{ statistics['totalReservationStat']['sameDayReservationUsingCnt'] + statistics['totalReservationStat']['afterDayReservationUsingCnt'] }}
                            </v-col>
                            <v-col class="text-center statistic-table__bottom-right">
                              {{ statistics['totalReservationStat']['sameDayReservationUserCnt'] + statistics['totalReservationStat']['afterDayReservationUserCnt'] }}
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="pa-10">
                          <div class="subtitle-1 text-center font-weight-bold mb-3">예약 취소 수</div>
                          <v-row>
                            <v-col cols="3" class="text-center font-weight-bold statistic-table">취소 유형</v-col>
                            <v-col class="text-center font-weight-bold statistic-table__right">주행 건수(건)</v-col>
                            <v-col class="text-center font-weight-bold statistic-table__right">탑승 인원(명)</v-col>
                            <v-col class="text-center font-weight-bold statistic-table__right">이용 건수(건)</v-col>
                            <v-col class="text-center font-weight-bold statistic-table__right">이용자 수(명)</v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="3" class="text-center statistic-table__bottom">정상 취소</v-col>
                            <v-col class="text-center statistic-table__bottom-right">{{ statistics['totalReservationStat']['legalCancels'] }}</v-col>
                            <v-col class="text-center statistic-table__bottom-right">{{ statistics['totalReservationStat']['legalCancelCustomers'] }}</v-col>
                            <v-col class="text-center statistic-table__bottom-right">{{ statistics['totalReservationStat']['legalCancelUsingCnt'] }}</v-col>
                            <v-col class="text-center statistic-table__bottom-right">{{ statistics['totalReservationStat']['legalCancelUserCnt'] }}</v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="3" class="text-center statistic-table__bottom">무단 취소</v-col>
                            <v-col class="text-center statistic-table__bottom-right">{{ statistics['totalReservationStat']['illegalCancels'] }}</v-col>
                            <v-col class="text-center statistic-table__bottom-right">{{ statistics['totalReservationStat']['illegalCancelCustomers'] }}</v-col>
                            <v-col class="text-center statistic-table__bottom-right">{{ statistics['totalReservationStat']['illegalCancelUsingCnt'] }}</v-col>
                            <v-col class="text-center statistic-table__bottom-right">{{ statistics['totalReservationStat']['illegalCancelUserCnt'] }}</v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="3" class="text-center statistic-table__bottom">합계</v-col>
                            <v-col class="text-center statistic-table__bottom-right">
                              {{ statistics['totalReservationStat']['legalCancels'] + statistics['totalReservationStat']['illegalCancels'] }}
                            </v-col>
                            <v-col class="text-center statistic-table__bottom-right">
                              {{ statistics['totalReservationStat']['legalCancelCustomers'] + statistics['totalReservationStat']['illegalCancelCustomers'] }}
                            </v-col>
                            <v-col class="text-center statistic-table__bottom-right">
                              {{ statistics['totalReservationStat']['legalCancelUsingCnt'] + statistics['totalReservationStat']['illegalCancelUsingCnt'] }}
                            </v-col>
                            <v-col class="text-center statistic-table__bottom-right">
                              {{ statistics['totalReservationStat']['legalCancelUserCnt'] + statistics['totalReservationStat']['illegalCancelUserCnt'] }}
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <v-card outlined>
                    <v-col cols="12">
                      <div class="page-title font-weight-bold">지역별 주행 이용 통계(건)</div>
                    </v-col>

                    <v-col cols="12" class="ml-2">
                      <span>관내 이동</span>
                      <span class="ml-10 mr-12">{{ statistics['totalDrivingUsageStat']['regionStat'] ? statistics['totalDrivingUsageStat']['regionStat']['관내이동'] : 0 }}</span>
                      <span>관외 이동</span>
                      <span class="ml-10 mr-12">{{ statistics['totalDrivingUsageStat']['regionStat'] ? statistics['totalDrivingUsageStat']['regionStat']['관외이동'] : 0 }}</span>
                    </v-col>
                    <v-col>
                      <v-row v-for="city in cityStatKeys" :key="city" class="flex-column">
                        <v-col>
                          <div class="d-flex flex-row ml-2">
                            <div class="font-weight-bold">{{ city }}</div>
                            <div class="font-weight-bold ml-5">{{ getTotalMapValue(cityStat[city]) }}</div>
                          </div>
                        </v-col>
                        <v-col>
                          <v-row class="flex-row ml-2" no-gutters>
                            <v-col cols="3" v-for="district in getDistrictKeys(cityStat[city])" :key="district">
                              <v-row no-gutters>
                                <v-col cols="8" style="height: 50px;" >{{ district }}</v-col>
                                <v-col cols="4">{{ cityStat[city][district] }}</v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="6" class="mt-3">
              <v-card outlined>
                <v-col cols="12">
                  <div class="page-title font-weight-bold">주행 이용 통계</div>
                </v-col>
                <v-col cols="12">
                  <v-row>
                    <v-col class="pa-10">
                      <div class="subtitle-1 text-center font-weight-bold mb-3">용도별 이용 현황</div>
                      <v-row>
                        <v-col cols="3" class="text-center font-weight-bold statistic-table">용도</v-col>
                        <v-col class="text-center font-weight-bold statistic-table__right">주행 건수(건)</v-col>
                        <v-col class="text-center font-weight-bold statistic-table__right">탑승 인원(명)</v-col>
                        <v-col class="text-center font-weight-bold statistic-table__right">이용 건수(건)</v-col>
                        <v-col class="text-center font-weight-bold statistic-table__right">이용자 수(명)</v-col>
                      </v-row>
                      <v-row v-for="purpose in purposeTypes" :key="purpose">
                        <v-col cols="3" class="text-center statistic-table__bottom">{{ purpose }}</v-col>
                        <v-col class="text-center statistic-table__bottom-right">{{ (statistics['totalDrivingUsageStat']['purposeStat'][purpose]) ? statistics['totalDrivingUsageStat']['purposeStat'][purpose]['주행건수'] : 0 }}</v-col>
                        <v-col class="text-center statistic-table__bottom-right">{{ (statistics['totalDrivingUsageStat']['purposeStat'][purpose]) ? statistics['totalDrivingUsageStat']['purposeStat'][purpose]['탑승인원'] : 0 }}</v-col>
                        <v-col class="text-center statistic-table__bottom-right">{{ (statistics['totalDrivingUsageStat']['purposeStat'][purpose]) ? statistics['totalDrivingUsageStat']['purposeStat'][purpose]['이용건수'] : 0 }}</v-col>
                        <v-col class="text-center statistic-table__bottom-right">{{ (statistics['totalDrivingUsageStat']['purposeStat'][purpose]) ? statistics['totalDrivingUsageStat']['purposeStat'][purpose]['이용자수'] : 0 }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="3" class="text-center statistic-table__bottom">합계</v-col>
                        <v-col
                               v-for="type in usageTypes"
                               :key="type.key"
                               class="text-center statistic-table__bottom-right">
                          {{ getTotalCountMapByUsageType(statistics['totalDrivingUsageStat']['purposeStat'], type) }}
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pa-10">
                      <div class="subtitle-1 text-center font-weight-bold mb-3">거리별 이용 현황</div>
                      <v-row>
                        <v-col cols="3" class="text-center font-weight-bold statistic-table">거리</v-col>
                        <v-col class="text-center font-weight-bold statistic-table__right">주행 건수(건)</v-col>
                        <v-col class="text-center font-weight-bold statistic-table__right">탑승 인원(명)</v-col>
                        <v-col class="text-center font-weight-bold statistic-table__right">이용 건수(건)</v-col>
                        <v-col class="text-center font-weight-bold statistic-table__right">이용자 수(명)</v-col>
                      </v-row>
                      <v-row v-for="type in drivingDistanceKeys" :key="type.key">
                        <v-col cols="3" class="text-center statistic-table__bottom">{{ type.text }}</v-col>
                        <v-col class="text-center statistic-table__bottom-right">{{ !!(statistics['totalDrivingUsageStat']['distanceStat'][type.key]) ? statistics['totalDrivingUsageStat']['distanceStat'][type.key]['주행건수'] : 0 }}</v-col>
                        <v-col class="text-center statistic-table__bottom-right">{{ !!(statistics['totalDrivingUsageStat']['distanceStat'][type.key]) ? statistics['totalDrivingUsageStat']['distanceStat'][type.key]['탑승인원'] : 0 }}</v-col>
                        <v-col class="text-center statistic-table__bottom-right">{{ !!(statistics['totalDrivingUsageStat']['distanceStat'][type.key]) ? statistics['totalDrivingUsageStat']['distanceStat'][type.key]['이용건수'] : 0 }}</v-col>
                        <v-col class="text-center statistic-table__bottom-right">{{ !!(statistics['totalDrivingUsageStat']['distanceStat'][type.key]) ? statistics['totalDrivingUsageStat']['distanceStat'][type.key]['이용자수'] : 0 }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="3" class="text-center statistic-table__bottom">합계</v-col>
                        <v-col
                               v-for="type in usageTypes"
                               :key="type.key"
                               class="text-center statistic-table__bottom-right">
                          {{ getTotalCountMapByUsageType(statistics['totalDrivingUsageStat']['distanceStat'], type) }}
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" class="pa-10">
                      <div class="subtitle-1 text-center font-weight-bold mb-3">회원 유형별 이용 현황</div>
                      <v-row>
                        <v-col cols="5" class="text-center font-weight-bold statistic-table">회원 유형</v-col>
                        <v-col class="text-center font-weight-bold statistic-table__right">탑승 인원(명)</v-col>
                        <v-col class="text-center font-weight-bold statistic-table__right">이용자 수(명)</v-col>
                      </v-row>
                      <v-row v-for="type in userTypes" :key="type.key">
                        <v-col cols="5" class="text-center statistic-table__bottom">{{ type.text }}</v-col>
                        <v-col class="text-center statistic-table__bottom-right">{{ statistics['totalDrivingUsageStat']['customerTypeStat']['탑승인원'][type.key] || 0 }}</v-col>
                        <v-col class="text-center statistic-table__bottom-right">{{ statistics['totalDrivingUsageStat']['customerTypeStat']['이용자수'][type.key] || 0 }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="5" class="text-center statistic-table__bottom">합계</v-col>
                        <v-col class="text-center statistic-table__bottom-right">{{ getTotalMapValue(statistics['totalDrivingUsageStat']['customerTypeStat']['탑승인원']) }}</v-col>
                        <v-col class="text-center statistic-table__bottom-right">{{ getTotalMapValue(statistics['totalDrivingUsageStat']['customerTypeStat']['이용자수']) }}</v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="6" class="pa-10">
                      <div class="subtitle-1 text-center font-weight-bold mb-3">장애 유형별 이용 현황</div>
                      <v-row>
                        <v-col cols="5" class="text-center font-weight-bold statistic-table">장애 유형</v-col>
                        <v-col class="text-center font-weight-bold statistic-table__right">탑승 인원(명)</v-col>
                        <v-col class="text-center font-weight-bold statistic-table__right">이용자 수(명)</v-col>
                      </v-row>
                      <v-row v-for="type in disabilityTypes" :key="type.key">
                        <v-col cols="5" class="text-center statistic-table__bottom">{{ type.text }}</v-col>
                        <v-col class="text-center statistic-table__bottom-right">{{ disabilityUsersByType[type.key] || 0 }}</v-col>
                        <v-col class="text-center statistic-table__bottom-right">{{ disabilityUsageByType[type.key] || 0 }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="5" class="text-center statistic-table__bottom">합계</v-col>
                        <v-col class="text-center statistic-table__bottom-right">
                          {{ getTotalMapValue(disabilityUsersByType) }}
                        </v-col>
                        <v-col class="text-center statistic-table__bottom-right">
                          {{ getTotalMapValue(disabilityUsageByType) }}
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-card>
            </v-col>
          </v-row>
          <v-card outlined>
            <v-col cols="12">
              <div class="page-title font-weight-bold">회원 현황</div>
            </v-col>
            <v-col>
              <v-row>
                <v-col>
                  <div class="pa-4">
                    <div class="subtitle-1 text-center font-weight-bold mb-3">회원 유형</div>
                    <v-row>
                      <v-col cols="7" class="text-center font-weight-bold statistic-table">회원 유형</v-col>
                      <v-col cols="5" class="text-center font-weight-bold statistic-table__right">인원(명)</v-col>
                    </v-row>
                    <v-row v-for="type in userTypes" :key="type.key">
                      <v-col cols="7" class="text-center statistic-table__bottom">{{ type.text }}</v-col>
                      <v-col cols="5" class="text-center statistic-table__bottom-right">{{ statistics['totalUserStat']['type'][type.key] || 0 }}</v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="7" class="text-center statistic-table__bottom">합계</v-col>
                      <v-col cols="5" class="text-center statistic-table__bottom-right">{{ getTotalMapValue(statistics['totalUserStat']['type']) }}</v-col>
                    </v-row>
                  </div>
                </v-col>
                <v-col>
                  <div class="pa-4">
                    <div class="subtitle-1 text-center font-weight-bold mb-3">연령대</div>
                    <v-row>
                      <v-col cols="7" class="text-center font-weight-bold statistic-table">연령대</v-col>
                      <v-col cols="5" class="text-center font-weight-bold statistic-table__right">인원(명)</v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="7" class="text-center statistic-table__bottom">~ 19</v-col>
                      <v-col cols="5" class="text-center statistic-table__bottom-right">{{ statistics['totalUserStat']['age']['under20'] }}</v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="7" class="text-center statistic-table__bottom">20 ~ 29</v-col>
                      <v-col cols="5" class="text-center statistic-table__bottom-right">{{ statistics['totalUserStat']['age']['over20under30'] }}</v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="7" class="text-center statistic-table__bottom">30 ~ 39</v-col>
                      <v-col cols="5" class="text-center statistic-table__bottom-right">{{ statistics['totalUserStat']['age']['over30under40'] }}</v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="7" class="text-center statistic-table__bottom">40 ~ 49</v-col>
                      <v-col cols="5" class="text-center statistic-table__bottom-right">{{ statistics['totalUserStat']['age']['over40under50'] }}</v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="7" class="text-center statistic-table__bottom">50 ~ 59</v-col>
                      <v-col cols="5" class="text-center statistic-table__bottom-right">{{ statistics['totalUserStat']['age']['over50under60'] }}</v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="7" class="text-center statistic-table__bottom">60 ~</v-col>
                      <v-col cols="5" class="text-center statistic-table__bottom-right">{{ statistics['totalUserStat']['age']['over60'] }}</v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="7" class="text-center statistic-table__bottom">합계</v-col>
                      <v-col cols="5" class="text-center statistic-table__bottom-right">{{ getTotalMapValue(statistics['totalUserStat']['age']) }}</v-col>
                    </v-row>
                  </div>
                </v-col>
                <v-col>
                  <div class="pa-4">
                    <div class="subtitle-1 text-center font-weight-bold mb-3">성별</div>
                    <v-row>
                      <v-col cols="7" class="text-center font-weight-bold statistic-table">성별</v-col>
                      <v-col cols="5" class="text-center font-weight-bold statistic-table__right">인원(명)</v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="7" class="text-center statistic-table__bottom">남자</v-col>
                      <v-col cols="5" class="text-center statistic-table__bottom-right">{{ statistics['totalUserStat']['gender']['M'] }}</v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="7" class="text-center statistic-table__bottom">여자</v-col>
                      <v-col cols="5" class="text-center statistic-table__bottom-right">{{ statistics['totalUserStat']['gender']['F'] }}</v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="7" class="text-center statistic-table__bottom">합계</v-col>
                      <v-col cols="5" class="text-center statistic-table__bottom-right">{{ getTotalMapValue(statistics['totalUserStat']['gender']) }}</v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-card>
        </v-card>
      </template>
    </contents-layout>
  </v-container>

</template>

<script>
import StatInfoCard from "@/views/CallTaxi/monitoring/StatInfoCard";

export default {
  components: {StatInfoCard},
  data() {
    return {
      appVersion: '',
      startMenu: false,
      endMenu: false,
      startDate: this.$moment().subtract(1, 'months').format('YYYY-MM-DD'),
      limitedDate: this.$moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'),
      endDate: this.$moment().subtract(1, 'days').format('YYYY-MM-DD'),
      purposeTypes: this.$store.state.centerInfo.useList.split(','),
      lineChartData: {},
      barChartData: {},
      requestsByDay: {
        '월': {usages: 0, count: 0},
        '화': {usages: 0, count: 0},
        '수': {usages: 0, count: 0},
        '목': {usages: 0, count: 0},
        '금': {usages: 0, count: 0},
        '토': {usages: 0, count: 0},
        '일': {usages: 0, count: 0}
      },
      doneDrivingsByDay: {
        '월': {usages: 0, count: 0},
        '화': {usages: 0, count: 0},
        '수': {usages: 0, count: 0},
        '목': {usages: 0, count: 0},
        '금': {usages: 0, count: 0},
        '토': {usages: 0, count: 0},
        '일': {usages: 0, count: 0}
      },
      usageTypes: [
        { key: "주행건수", text: "주행 건수", unit: "건" },
        { key: "탑승인원", text: "탑승 인원", unit: "명" },
        { key: "이용건수", text: "이용 건수", unit: "건" },
        { key: "이용자수", text: "이용자 수", unit: "명" },
      ],
      userTypes: [
        {key: "일반", text: "일반"},
        {key: "장애인", text: "교통약자(장애인)"},
        {key: "영유아 가정", text: "교통약자(영유아 동반자)"},
        {key: "임산부", text: "교통약자(임산부)"},
        {key: "영유아", text: "교통약자(어린이)"},
        {key: "고령자", text: "교통약자(고령자)"},
        {key: "보호자", text: "보호자"},
      ],
      dayKeys: ['월', '화', '수', '목', '금', '토', '일'],
      disabilityTypeKeys: ['간', '뇌전증', '뇌병변', '시각', '신장', '심장', '안면', '언어', '자폐성', '장루,요루', '정신', '지적', '지체', '청각', '호흡기', '일시적장애', '기타'],
      disabilityTypes: [
        {key: '간', text:'간'},
        {key: '뇌전증', text:'뇌전증'},
        {key: '뇌병변', text:'뇌병변'},
        {key: '시각', text:'시각'},
        {key: '신장', text:'신장'},
        {key: '심장', text:'심장'},
        {key: '안면', text:'안면'},
        {key: '언어', text:'언어'},
        {key: '자폐성', text:'자폐성'},
        {key: '장루,요루', text:'장루, 요루'},
        {key: '정신', text:'정신'},
        {key: '지적', text:'지적'},
        {key: '지체', text:'지체'},
        {key: '청각', text:'청각'},
        {key: '호흡기', text:'호흡기'},
        {key: '일시적장애', text:'일시적 장애'},
        {key: '기타', text:'기타'}
      ],
      drivingDistanceKeys: [
        {
          key: '10미만',
          text: '10km 미만',
        },
        {
          key: '10~20km',
          text: '10 ~ 20km',
        },
        {
          key: '20~30km',
          text: '20 ~ 30km',
        },
        {
          key: '30이상',
          text: '30km 이상',
        },
      ],
      statistics: {
        totalDrivingCumulativeStat: {
          drivings: 0,
          customers: 0,
          totalUsageTime: 0,
          helpServiceTimes: 0,
          helpServiceCustomers: 0,
          totalDistances: 0,
          averageDistance: 0,
          deliveries: 0
        },
        totalFareStat: {
          total: 0,
          driving: 0,
          waiting: 0,
          service: 0,
          extra: 0,
          discount: 0,
          delivery: 0,
          unpaid: 0,
          payWithCash: 0,
          payWithCard: 0
        },
        totalReservationStat: {
          totalRequests: 0,
          doneDrivings: 0,
          reservations: 0,
          sameDayReservations: 0,
          sameDayReservationCustomers: 0,
          sameDayReservationUsingCnt: 0,
          sameDayReservationUserCnt: 0,
          afterDayReservations: 0,
          afterDayReservationCustomers: 0,
          afterDayReservationUsingCnt: 0,
          afterDayReservationUserCnt: 0,
          legalCancels: 0,
          legalCancelCustomers: 0,
          legalCancelUsingCnt: 0,
          legalCancelUserCnt: 0,
          illegalCancels: 0,
          illegalCancelCustomers: 0,
          illegalCancelUsingCnt: 0,
          illegalCancelUserCnt: 0,
        },
        serviceUsageReservations: [
          {
            requests: 0,
            doneDrivings: 0,
            targetDate: ""
          }
        ],
        totalDrivingUsageStat: {
          cityStat: {},
          urbanStat: {
            '시내': 0,
            '시외': 0
          },
          purposeStat: {
            '출타/귀가': {
              '탑승인원': 0,
              '주행건수': 0,
              '이용건수': 0,
              '이용자수': 0,
            }
          },
          distanceStat: {
            '10미만': {
              '탑승인원': 0,
              '주행건수': 0,
              '이용건수': 0,
              '이용자수': 0,
            },
            '10~20km': {
              '탑승인원': 0,
              '주행건수': 0,
              '이용건수': 0,
              '이용자수': 0,
            },
            '20~30km': {
              '탑승인원': 0,
              '주행건수': 0,
              '이용건수': 0,
              '이용자수': 0,
            },
            '30이상': {
              '탑승인원': 0,
              '주행건수': 0,
              '이용건수': 0,
              '이용자수': 0,
            }
          },
          customerTypeStat: {
            '탑승인원': {
              '임산부': 0,
              '일반': 0,
              '장애인': 0
            },
            '이용자수': {
              '임산부': 0,
              '일반': 0,
              '장애인': 0
            },
          },
          disabilityStat: {
            degree: {},
            type: {}
          },
          userCntByDisabilityStat: {
            degree: {},
            type: {}
          },
          regionStat: {
            '관내이동': 0,
            '관외이동': 0
          }
        },
        totalUserStat: {
          centerId: "",
          type: {},
          age: {
            over50under60: 0,
            over20under30: 0,
            over60: 0,
            under20: 0,
            over30under40: 0,
            over40under50: 0
          },
          gender: {
            F: 0,
            M: 0
          }
        }
      },
    }
  },

  mounted() {
    this.appVersion = process.env.VUE_APP_SERVICE;
    this.getStatisticData();
  },

  methods: {
    allowDates(date) {
      return this.$moment(date, 'YYYY-MM-DD').isBefore(this.$moment());
    },
    initUsageByDayMap() {
      this.requestsByDay = {
        '월': {usages: 0, count: 0},
        '화': {usages: 0, count: 0},
        '수': {usages: 0, count: 0},
        '목': {usages: 0, count: 0},
        '금': {usages: 0, count: 0},
        '토': {usages: 0, count: 0},
        '일': {usages: 0, count: 0}
      },
      this.doneDrivingsByDay = {
        '월': {usages: 0, count: 0},
        '화': {usages: 0, count: 0},
        '수': {usages: 0, count: 0},
        '목': {usages: 0, count: 0},
        '금': {usages: 0, count: 0},
        '토': {usages: 0, count: 0},
        '일': {usages: 0, count: 0}
      }
    },
    numberFormatter(val) {
      return this.$func.numberFormatter(val);
    },
    getDistrictKeys(map) {
      return Object.keys(map).sort();
    },
    toKilometer: (value) => (value / 1000).toFixed(1),
    toFormatTime: (value) => {
      const totalMin = Math.floor(value / 60);
      if (totalMin < 60) {
        return totalMin + " 분";
      } else {
        const hours = Math.floor(totalMin / 60);
        const min = totalMin % (hours * 60);

        return `${hours}시간 ${min}분`;
      }
    },

    async getStatisticData() {
      const {data} = await this.$api.getStatisticData(this.startDate, this.endDate);
      this.statistics = data;

      this.fillServiceChartData();
    },

    getTotalMapValue(map) {
      return Object.values(map).reduce((acc, cur) => acc + cur, 0);
    },

    getTotalCountInMapValue(map) {
      return Object.values(map).reduce((acc, cur) => acc + cur['건수'], 0);
    },

    getTotalCustomersInMapValue(map) {
      return Object.values(map).reduce((acc, cur) => acc + cur['인원'], 0);
    },

    getTotalCountMapByUsageType(map, type) {
      return Object.values(map).reduce((acc, cur) => acc + cur[type.key], 0);
    },

    fillServiceChartData() {
      this.lineChartData = {
        labels: this.serviceReservations.map(item => item.targetDate.substring(5)),
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: 20,
            },
            gridLines: {
              display: true,
              drawBorder: false,
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              autoSkip: true,
              maxTicksLimit: 8
            }
          }],
        },
        legend: {
          position: 'bottom'
        },
        datasets: [
          {
            label: '신청 건수(건)',
            fill: false,
            backgroundColor: 'blue',
            borderColor: 'blue',
            borderWidth: 3,
            data: this.serviceReservations.map(item => item.requests)
          },
          {
            label: '주행 건수(건)',
            fill: false,
            backgroundColor: 'orange',
            borderColor: 'orange',
            borderWidth: 3,
            data: this.serviceReservations.map(item => item.doneDrivings)
          }
        ]
      };

      this.initUsageByDayMap();
      this.statistics['serviceUsageReservations'].forEach(item => {
        const dayIndex = this.$moment(item.targetDate).isoWeekday();
        const day = this.dayKeys[dayIndex - 1];
        this.requestsByDay[day].usages += item.requests;
        this.requestsByDay[day].count += 1;
        this.doneDrivingsByDay[day].usages += item.doneDrivings;
        this.doneDrivingsByDay[day].count += 1;
      });

      this.barChartData = {
        labels: ['월', '화', '수', '목', '금', '토', '일'],
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: 20,
            },
            gridLines: {
              display: true,
              drawBorder: false,
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            },
          }]
        },
        legend: {
          position: 'bottom'
        },
        datasets: [
          {
            label: '신청 건수(건)',
            backgroundColor: 'blue',
            data: this.sortedRequest
          },
          {
            label: '주행 건수(건)',
            backgroundColor: 'orange',
            data: this.sortedDoneDrivings
          }
        ]
      };
    },
  },

  watch: {
    startDate() {
      this.getStatisticData(this.startDate, this.endDate);
    },
    endDate() {
      this.getStatisticData(this.startDate, this.endDate);
    }
  },
  computed: {
    disabilityUsersByType() {
      const initializedDisabilityTypes = {'간': 0, '뇌전증': 0, '뇌병변': 0, '시각': 0, '신장': 0, '심장': 0, '안면': 0, '언어': 0, '자폐성': 0, '장루,요루': 0, '정신': 0, '지적': 0, '지체': 0, '청각': 0, '호흡기': 0, '일시적 장애': 0, '기타': 0 };
      if (!this.statistics.totalDrivingUsageStat.disabilityStat.type) {
        return initializedDisabilityTypes;
      }

      return Object.keys(this.statistics.totalDrivingUsageStat.disabilityStat.type).reduce((acc, disabilityKey) => {
        acc[disabilityKey] = this.statistics.totalDrivingUsageStat.disabilityStat.type[disabilityKey]
        return acc;
      }, initializedDisabilityTypes);
    },
    disabilityUsageByType() {
      const initializedDisabilityTypes = {'간': 0, '뇌전증': 0, '뇌병변': 0, '시각': 0, '신장': 0, '심장': 0, '안면': 0, '언어': 0, '자폐성': 0, '장루,요루': 0, '정신': 0, '지적': 0, '지체': 0, '청각': 0, '호흡기': 0, '일시적 장애': 0, '기타': 0 };
      if (!this.statistics.totalDrivingUsageStat.userCntByDisabilityStat.type) {
        return initializedDisabilityTypes;
      }

      return Object.keys(this.statistics.totalDrivingUsageStat.userCntByDisabilityStat.type).reduce((acc, disabilityKey) => {
        acc[disabilityKey] = this.statistics.totalDrivingUsageStat.userCntByDisabilityStat.type[disabilityKey]
        return acc;
      }, initializedDisabilityTypes);
    },
    serviceReservations() {
      return this.statistics['serviceUsageReservations'].sort((a, b) => {
        const d1 = this.$moment(a.targetDate);
        const d2 = this.$moment(b.targetDate);
        return d1.valueOf() - d2.valueOf();
      });
    },
    cityStat() {
      return this.statistics['totalDrivingUsageStat']['cityStat'];
    },
    cityStatKeys() {
      return Object.keys(this.statistics['totalDrivingUsageStat']['cityStat']).sort();
    },
    sortedRequest() {
      return this.dayKeys.map(day => (this.requestsByDay[day].usages / this.requestsByDay[day].count).toFixed(1));
    },
    sortedDoneDrivings() {
      return this.dayKeys.map(day => (this.doneDrivingsByDay[day].usages / this.requestsByDay[day].count).toFixed(1));
    },
    reservationRate() {
      const rate = (this.statistics['totalReservationStat']['reservations'] / this.statistics['totalReservationStat']['totalRequests'] * 100).toFixed(1);
      return isNaN(parseInt(rate)) ? 0 : rate;
    },
    sameDayReservationRate() {
      const rate = (this.statistics['totalReservationStat']['sameDayReservations'] / this.statistics['totalReservationStat']['totalRequests'] * 100).toFixed(1);
      return isNaN(parseInt(rate)) ? 0 : rate;
    },
    doneDrivingRate() {
      const rate = (this.statistics['totalReservationStat']['doneDrivings'] / this.statistics['totalReservationStat']['totalRequests'] * 100).toFixed(1);
      return isNaN(parseInt(rate)) ? 0 : rate;
    },
    cumulativeStat() {
      return this.statistics['totalDrivingCumulativeStat'];
    },
    purposeStatKeys() {
      return Object.keys(this.statistics['totalDrivingUsageStat']['purposeStat']);
    },
    distanceStatKeys() {
      return Object.keys(this.statistics['totalDrivingUsageStat']['distanceStat']);
    },
  },
}
</script>
<style>
.statistic-table {
  border: solid 1px;
}

.statistic-table__right {
  border-style: solid solid solid none;
  border-width: thin;
}

.statistic-table__bottom {
  border-style: none solid solid solid;
  border-width: thin;
}

.statistic-table__bottom-right {
  border-style: none solid solid none;
  border-width: thin;
}
</style>
